import * as PostActionTypes from '../../../constants/contents/PostActionTypes';

const initialState = {
    searchKeyword : '',
    searchType : 'title',
    category : null,
    visibility : 'all',
};

export default (state = initialState, action) => {
    switch (action.type) {
        case PostActionTypes.CLEAR_ITEMS:
            return {
                searchKeyword : '',
                searchType : 'title',
                category : null,
                visibility : 'all',
            };
        case PostActionTypes.FILTER_CATEGORY:
            if(state.category !== action.category)
                return Object.assign({}, state, {
                    category: action.category
                });
            else
                return state;
        case PostActionTypes.FILTER_VISIBILITY:
            if(state.visibility !== action.visibility)
                return Object.assign({}, state, {
                    visibility: action.visibility
                });
            else
                return state;
        case PostActionTypes.SEARCH_KEYWORD:
            return Object.assign({}, state, {
                searchKeyword: action.searchKeyword,
                searchType: action.searchType,
            });
        default :
            return state;
    }
}
